import React, { Component } from 'react';
import { connect } from 'react-redux';
import ActionLoader from 'Components/ActionLoader';
import Sticky from 'Components/Sticky';
import { ReactComponent as BackIcon } from 'Icons/leftback.svg';
import ContractDetails from './contractDetails';
import Trips from './Trips';
import {
    DOWNLOAD_UPLOADED_FILE,
    GET_PRICING_BASIS,
    GET_VENDOR_LIST,
    UPLOAD_DOCUMENT,
    DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE,
    UPLOAD_SECONDARY_CONTRACT_TRIPS,
    SAVE_SECONDARY_CONTRACTS,
    GET_VEHICLE_TYPES,
    GET_CONTRACT_BY_RFQId,
    GET_SECONDARY_CONTRACT_CFA_DETAILS,
    UPDATE_SECONDARY_CONTRACTS,
    DELETE_SECONDARY_CONTRACT_RFQ_TRIP,
    GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS,
    GET_TRANSPORTERS_LIST,
    SECONDARY_CONTRACT_TENURE_VALIDATION,
    GET_PRODUCT_CATEGORIES
} from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import { isEmami, isSapDPL, isVishaka } from 'Utils/index';
class AddSecondaryContracts extends Component {
    constructor(){
        super();
        this.state = {
            contractPage: 1,
            searchText : "",
            contractData: {
                trips: [{
                    stops: [{
                        "type": 1,
				        "sequence": 1
                    }, {
                        "type": 2,
				        "sequence": 2
                    }]
                }],
                rfq_name: '',
                contract_type_name: '',
                contract_type_id:  '',
                contract_tenure_from: new Date(),
                contract_tenure_to: null,
                vendor_id: '',
                vendor_name: '',
                movement_type: '',
                movement_type_name: '',
                pricing_basis_id: '',
                pricing_basis: '',
                dph_applicable: '',
                tat_master_applicable: '',
                service_mode_id: '',
                service_mode_name: '',
                distribution_mode_id: '',
                distribution_mode_name: '',
                pick_up_date_includes: false,
                delivery_date_includes: false,
                docs: []
            },
            tripsDataEdited:false,
            rfqDataEdited:false,
            limit: 100,
            offset: 0
        }
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        if(isEmami() || isSapDPL() || isVishaka()) {
            dispatch({
                type: GET_TRANSPORTERS_LIST,
                params: {
                    companyId: getUser().companyId,
                    branchId: getUser().branchId,
                    type: 2,
                    isMultimode: false
                }
            })
        } else {
            dispatch({
                type: GET_VENDOR_LIST,
                params: {
                    companyId: getUser().companyId
                }
            });
        }
        dispatch({
            type: GET_PRICING_BASIS,
            data: {
                rfqType: isEmami() ? 3 : 1,
                companyId: getUser().companyId,
                branchId: getUser().companyId
            }
        });
        dispatch({
            type: GET_VEHICLE_TYPES, 
            params: {
                rfqType: 1,
                companyId: getUser().companyId
            }
        });
        if(isSapDPL()) {
            dispatch({
                type: GET_PRODUCT_CATEGORIES,
                data: {
                    rfqType: 1,
                    companyId: getUser().companyId
                }
            })
        }
        dispatch({
            type: GET_SECONDARY_CONTRACT_CFA_DETAILS
        })
        if(match.params.isView) {
            this.getContratById();
        } else if(isEmami()) {
            const { contractData } = this.state;
            if(!contractData.contract_type_id) {
                this.onSelectContractType(3, 'Dedicated Contract');
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, props) {
        if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
           this.handleContractTenureValidation();
        }
     } 

    getContratById = () => {
        const { dispatch, match } = this.props;
        const { limit, offset  } = this.state;
        dispatch({
            type: GET_CONTRACT_BY_RFQId,
            data: {
                rfqId: (match.params || {}).rfqId,
                limit,
                offset
            },
            onSuccess: (data) => {
                if(data) {
                    this.setState({
                        contractData: {
                            trips: data.trips,
                            ...data.rfq
                        },
                        totalTrips: data.secondary_trip_count
                    });

                }
            }
        })
    }

    onSelect = (option, name, id) => {
        const { contractData } = this.state;
        const {match}=this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        contractData[name] = option.name;
        contractData[id] = option.value;
        this.setState({
            contractData
        }, () => {
            if(name == 'vendor_name') {
                this.handleContractTenureValidation();
            }
        });
        if(isEdit){
        this.setState((prevState) => {
            const updateState = { ...prevState };
            updateState.rfqDataEdited = true;
            return updateState;
          });
        }  
    }

    onSelectContractType = (id, name) => {
        const { contractData } = this.state;
        contractData['contract_type_id'] = id;
        contractData['contract_type_name'] = name;
        if(id === 5 || id === 3) {
            if(!isSapDPL()) {
                contractData.trips[0]['touch_points'] = [{
                    city: '',
                    state: ''
                }];
            }
            if(id === 3) {
                if(isEmami()) {
                    contractData.trips = [{
                        'dedicated_variable_cost': [{
                            'variable_charges': '',
                            'variable_cost': '',
                            'pricing_basis': ''
                        }]
                    }]
                } else if(isSapDPL()) {
                    delete contractData.trips[0]['stops'];
                } else {
                    contractData.trips[0]['dedicated_variable_cost'] = [{
                        variable_cost: '',
                        variable_quantity: '',
                        variable_uom: ''
                    }]
                }
            }
        }
        this.setState({
            contractData
        });
    }

    onDatesChange = (startDate, endDate) => {
        const { contractData } = this.state;
        const {match}=this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0);
        contractData['contract_tenure_from'] = startDateTime;
        const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
        contractData['contract_tenure_to'] = endTime ? new Date(endTime).getTime() : contractData['contract_tenure_to'];
        this.setState({
            contractData
        }, this.handleContractTenureValidation);
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.rfqDataEdited = true;
                return updateState;
              });
            } 
        
    }

    uploadDocument = (file) => {
        const  { dispatch,match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            onSuccess: (data) => { 
               const { contractData } = this.state;
               contractData.docs.push(data);
               this.setState({
                    contractData
                });
            }
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.rfqDataEdited = true;
                return updateState;
              });
            } 
    }

    downloadUploadedFile = (fileName) => {
        const { dispatch } =  this.props;
        dispatch({
           type: DOWNLOAD_UPLOADED_FILE,
           param: {
              fileName,
              companyId: getUser().companyId
           }
        });
    }

     deleteDoc = (index) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        contractData.docs.splice(index, 1);
        this.setState({ contractData });
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.rfqDataEdited = true;
                return updateState;
              });
            }
     }

    onChangePage = (id) => {
        this.setState({
            contractPage: id
        })
    }

    onChangeTrips = (index, field, e) => {
        const { contractData } = this.state; 
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(field === 'from') {
            contractData.trips[index].stops[0] = e;
            contractData.trips[index][field] = e.city || (((e.location && e.location.split(", ") || [])[0]) || '');
        } else if(field === 'to') {
            contractData.trips[index].stops[1] = { ...e };
            contractData.trips[index][field] = e.city || (((e.location && e.location.split(", ") || [])[0]) || '');
        } else if(['variable_quantity_uom', 'minimum_quantity_uom', 'tat', 'monthly_amount', 'gst_applicability', 'type_of_charges'].includes(field)) {
            contractData.trips[index][field] = e;
        } else if(field === 'vehicle_type_id') {
            contractData.trips[index][field] = e.value;
            contractData.trips[index]['vehicle_type_name'] = e.name;   
        } else if (['qbr', 'minimum_quantity', 'gst_percentage', 'variable_cost','variable_quantity', 'to_pincode', 'minimum_km', 'fixed_cost', 'fixed_price'].includes(field)){ 
            contractData.trips[index][field] = e.target.value ?  Number(e.target.value) : '';
        } else if(['fromState', 'toState', 'fromCity', 'toCity'].includes(field)) {
            if(['fromState', 'toState'].includes(field)) {
                contractData.trips[index].stops[field === 'fromState' ? 0 : 1]['state'] = e.target.value;
            } else if(['fromCity', 'toCity'].includes(field)) {
                contractData.trips[index][field === 'fromCity' ? 'from' : 'to'] = e.target.value;
                contractData.trips[index].stops[field === 'fromCity' ? 0 : 1] = {
                    city: e.target.value,
                    location: e.target.value
                }
            }
        } else if(field === 'pricing_basis') {
            contractData.trips[index]['pricing_basis_id'] = e.value;
            contractData.trips[index]['pricing_basis'] = e.name;  
        } else if(['fixed_price_uom', 'variable_cost_uom'].includes(field)) {
            contractData.trips[index][`${field}_id`] = e.value;
            contractData.trips[index][field] = e.name;  
        } else if(field == 'trip_type_name') {
            contractData.trips[index]['trip_type_id'] = e.value;
            contractData.trips[index]['trip_type_name'] = e.name;  
        }else {
            contractData.trips[index][field] = e.target.value;
        }
        this.setState({
            contractData
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onChangeTripsTouchPoints = (index, field, tripIndex,e) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(field === 'from') {
            const data = contractData.trips[tripIndex]['touch_points'][index];
            contractData.trips[tripIndex]['touch_points'][index] = {
                ...data,
                ...e
            }
        }else if (field === 'pincode') {
            contractData.trips[tripIndex]['touch_points'][index][field] = e.value;
        }else if (field === 'tat') {
            contractData.trips[tripIndex]['touch_points'][index][field] = e;
        }else {
            contractData.trips[tripIndex]['touch_points'][index]['point_type'] = e.value;
            contractData.trips[tripIndex]['touch_points'][index]['point_type_name'] = e.name;
        }
        this.setState({
            contractData
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onSaveRFQ = () => {
        const { contractData, rfqDataEdited, tripsDataEdited } = this.state;
        const { dispatch, history, match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        let data = {};
        if(isEdit) {
            data = {
                rfq_id: contractData.rfq_id,
            }

                if (!!rfqDataEdited) {
                    data.rfq={
                                rfq_name : contractData.rfq_name, 
                                contract_type_name : contractData.contract_type_name, 
                                contract_type_id : contractData.contract_type_id, 
                                contract_tenure_from : contractData.contract_tenure_from, 
                                contract_tenure_to : contractData.contract_tenure_to, 
                                vendor_id : contractData.vendor_id, 
                                vendor_name : contractData.vendor_name,
                                movement_type : contractData.movement_type, 
                                movement_type_name : contractData.movement_type_name, 
                                pricing_basis_id : contractData.pricing_basis_id, 
                                pricing_basis : contractData.pricing_basis, 
                                dph_applicable : contractData.dph_applicable, 
                                tat_master_applicable : contractData.tat_master_applicable, 
                                service_mode_id :contractData.service_mode_id, 
                                service_mode_name : contractData.service_mode_name, 
                                distribution_mode_id : contractData.distribution_mode_id, 
                                distribution_mode_name : contractData.distribution_mode_name, 
                                docs : contractData.docs, 
                                dph_applicable_name : contractData.dph_applicable_name, 
                                tat_master_applicable_name : contractData.tat_master_applicable_name, 
                                diesel_price_rate : contractData.diesel_price_rate, 
                                diesel_price_date : contractData.diesel_price_date,
                                pick_up_date_includes : contractData.pick_up_date_includes,
                                delivery_date_includes : contractData.delivery_date_includes,
                                number_of_vehicles : contractData.number_of_vehicles,
                                kilo_meter: contractData.kilo_meter,
                                capacity: contractData.capacity
                            }
                }
                if(!!tripsDataEdited){
                    data.trips = contractData.trips || []
                }
            } else {
                data = contractData
            }
            dispatch({
                type: isEdit ? UPDATE_SECONDARY_CONTRACTS : SAVE_SECONDARY_CONTRACTS,
                data,
                onSuccess: () => {
                    history.push('/secondaryContracts');
                }
            })
        }

    onDeleteTrip = (index, touchPoint,tripIndex) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(touchPoint) {
            contractData.trips[tripIndex]['touch_points'].splice(index, 1);
        } else {
            contractData.trips.splice(index, 1);
        }
        this.setState({
            contractData
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }
    onEditDeleteTrip=(tripId,tripIndex)=>{
        const { dispatch,match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(isEdit) {
        dispatch({
            type: DELETE_SECONDARY_CONTRACT_RFQ_TRIP,
            data: {
                tripId
            },
            onSuccess: () => {
                this.onDeleteTrip(tripIndex) 
            }
        });
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
    }
    }

    onAddTrip = (touchPoint, tripIndex) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(touchPoint) {
            contractData.trips[tripIndex]['touch_points'].push({
                city: '',
                state: ''
            });
        } else {
            contractData.trips.push({
                stops: [{
                    "type": 1,
                    "sequence": 1
                }, {
                    "type": 2,
                    "sequence": 2
                }],
                ...(contractData.contract_type_id === 3 ? { dedicated_variable_cost: [{}], touch_points: [{}] } : null),
                ...(contractData.contract_type_id === 5 ? { touch_points: [{}] } : null)
            });
        }
        this.setState({
            contractData
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onSearchTrip =(e)=>{
        const {searchText}=this.state;
        this.setState({
            searchText: e.target.value,
          });
        this.getSearchedData(searchText)
    }

    getSearchedData =(searchText)=>{
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS, 
            params: {
                search: searchText,
                rfqId: (match.params || {}).rfqId,
                limit: 100,
                offset: 0
            }
        }); 
    }

    onChange = (e, field) => {      
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        contractData[field] = (field === 'diesel_price_date' ? e : (['diesel_price_rate', 'number_of_vehicles'].includes(field) ? (e.target.value ? Number(e.target.value) : e.target.value) : e.target.value));
        this.setState({
            contractData
        });
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.rfqDataEdited = true;
                return updateState;
              });
            }
    }

    downloadTripsTemplate = (withData) => {
        const { contractData } = this.state;
        const { dispatch, match } = this.props;
        dispatch({
            type: DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE,
            params: {
                type: contractData.contract_type_id,
                withData,
                rfqId: (match.params || {}).rfqId
            }
        })
    }

    uploadTrips = (file) => {
        const { dispatch,match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        const { contractData } = this.state;
        dispatch({
            type: UPLOAD_SECONDARY_CONTRACT_TRIPS,
            file,
            params: {
                type: contractData.contract_type_id
            },
            onSuccess: (data) => {
                // const { contractData } = this.state;
                contractData.trips = data.trips || [];
                this.setState({
                    contractData
                })
            }
        })
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onClickBack = () => {
        const { contractPage } = this.state;
        if(contractPage === 1 || !contractPage) {
            this.props.history.push('/secondaryContracts');
        } else {
            this.onChangePage(1);
        }

    }

    onChangeDedicatedVC = (tripIndex, field, e, index) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        if(['vehicle_type', 'pricing_basis', 'variable_cost_trip'].includes(field)) {
            contractData.trips[tripIndex]['dedicated_variable_cost'][index][field] = e.name;
            contractData.trips[tripIndex]['dedicated_variable_cost'][index][`${field}_id`] = e.value;
        } else {
            contractData.trips[tripIndex]['dedicated_variable_cost'][index][field] = ((['variable_quantity_uom', 'variable_charges'].includes(field)) ? e : (e.target.value && Number(e.target.value) || e.target.value));
        }
        this.setState({
            contractData
        });
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onDeleteDedicatedVC = (tripIndex, index) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        contractData.trips[tripIndex]['dedicated_variable_cost'].splice(index, 1);
        this.setState({
            contractData
        });
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    onAddDedicatedVC = (tripIndex) => {
        const { contractData } = this.state;
        const  { match } = this.props;
        const isEdit = ((match.params || {}).isView === 'false');
        contractData.trips[tripIndex]['dedicated_variable_cost'].push({
            variable_cost: '',
            variable_quantity: '',
            variable_uom: ''
        })
        this.setState({
            contractData
        });
        if(isEdit){
            this.setState((prevState) => {
                const updateState = { ...prevState };
                updateState.tripsDataEdited = true;
                return updateState;
              });
            }
    }

    handleContractTenureValidation = () => {
        const { contractData } = this.state;
        const { dispatch, selectedNavBranch } = this.props;
        if(isEmami() && contractData.vendor_id && contractData.contract_tenure_from) {
            dispatch({
                type: SECONDARY_CONTRACT_TENURE_VALIDATION,
                data: {
                    branch_id: (selectedNavBranch || {}).branch_id || getUser().branchId,
                    contract_tenure_from: contractData.contract_tenure_from,
                    vendor_id: contractData.vendor_id
                },
                onSuccess: (data) => {
                    this.setState({
                        contractExist: (data || {}).is_contractexist
                    });
                },
                onError: (data) => {
                    this.setState({
                        contractExist: ((data || {}).list || {}).is_contractexist
                    });
                }
            })
        }
    }

    goToPage = (pageNumber) => {
        const { limit } = this.state;
        this.setState({
            offset: (pageNumber - 1) * limit
        }, () => {
            this.getContratById();
        })
    }

    render() {
        const { 
            loader,
            vendorlist,
            pricingBasis,
            vehicleTypes,
            match,
            cfaDetails,
            searchedSecondaryCotractRfqTrips,
            transportersList,
            productCategories
        } = this.props;

        const { 
            contractPage,
            contractData,
            contractExist,
            totalTrips,
            limit, 
            offset
        } = this.state;

        const isView = ((match.params || {}).isView === 'true');
        const isEdit = ((match.params || {}).isView === 'false');

        return (
            <div style={{ backgroundColor: "#e3e9ff", minHeight: "820px" }}>
                {loader && 
                    <ActionLoader 
                        fixed={true}
                    />
                }
                
                <Sticky>
                    <div className='pv-20 ph-20 secondary-contract'>
                        <div className='flex'>
                            <div className='flex fs-22 dark-blue mr-30 curP' onClick={this.onClickBack}><BackIcon className="ml-5 curP mr-3"/><span className='fSemibold pt-8'>{'Back'}</span></div>
                            <div className='fs-28 fBold pt-5'>{contractPage === 1 ? 'Contract Details' : contractData.contract_type_name}</div>
                        </div>
                        {contractPage === 1 && 
                            <ContractDetails 
                                data = {contractData}
                                vendorlist = {vendorlist}
                                onSelect = {this.onSelect}
                                onDatesChange = {this.onDatesChange}
                                onChange = {this.onChange}
                                onSelectContractType = {this.onSelectContractType}
                                uploadDocument = {this.uploadDocument}
                                downloadUploadedFile = {this.downloadUploadedFile}
                                deleteDoc = {this.deleteDoc}
                                onChangePage = {this.onChangePage}
                                onClickBack = {this.onClickBack}
                                isView={isView}
                                isEdit={isEdit}
                                transportersList={transportersList}
                                contractExist={contractExist}
                            />
                        }
                        {
                            contractPage === 2 && 
                            <Trips 
                                onChangePage = {this.onChangePage}
                                onChange = {this.onChange}
                                data = {contractData}
                                onChangeTrips = {this.onChangeTrips}
                                onSaveRFQ = {this.onSaveRFQ}
                                onAddTrip={this.onAddTrip}
                                onDeleteTrip={this.onDeleteTrip}
                                onEditDeleteTrip={this.onEditDeleteTrip}
                                pricingBasis={pricingBasis}
                                downloadTripsTemplate={this.downloadTripsTemplate}
                                uploadTrips={this.uploadTrips}
                                onSelect = {this.onSelect}
                                onChangeTripsTouchPoints = {this.onChangeTripsTouchPoints}
                                onChangeDedicatedVC = {this.onChangeDedicatedVC}
                                onDeleteDedicatedVC = {this.onDeleteDedicatedVC}
                                onAddDedicatedVC = {this.onAddDedicatedVC}
                                vehicleTypes={vehicleTypes}
                                cfaDetails={cfaDetails}
                                isView={isView}
                                isEdit={isEdit}
                                searchText={this.state.searchText}
                                onSearchTrip={this.onSearchTrip}
                                searchedSecondaryCotractRfqTrips={searchedSecondaryCotractRfqTrips}
                                goToPage={this.goToPage}
                                limit={limit}
                                offset={offset}
                                totalTrips={totalTrips}
                                productCategories={productCategories}
                            />
                        }
                    </div>
                </Sticky>
            </div>
        )
    }
}

const mapStateToProps = ({ contracting, constants }) => {
    return {
        loader: contracting.loader,
        vendorlist: constants.vendorList || [],
        pricingBasis: constants.pricingBasis || [],
        vehicleTypes: constants.vehicleTypes || [],
        cfaDetails: constants.cfaDetails || [],
        searchedSecondaryCotractRfqTrips: constants.searchedSecondaryCotractRfqTrips || [],
        transportersList: constants.transportersList || [],
        selectedNavBranch: constants.selectedNavBranch || {},
        productCategories: constants.productCategories || [],
    }
}
export default connect(mapStateToProps)(AddSecondaryContracts);